module.exports = __webpack_public_path__ + "e0a68717d67598ed1319364c71a9618e.png";